// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".downloadButtonContainer-DESKTOP[data-v-738ee66e]{width:350px}.crossrefLogo[data-v-738ee66e]{float:left;height:100%;text-align:center;width:100px}.crossrefLogo img[data-v-738ee66e]{max-width:100px}.crossrefLogo-MOBILE[data-v-738ee66e]{width:100%}.citationHeading[data-v-738ee66e]{height:100%;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
